import { render } from "./AlimtalkDetailDrawer.vue?vue&type=template&id=1153035b&scoped=true"
import script from "./AlimtalkDetailDrawer.vue?vue&type=script&lang=js"
export * from "./AlimtalkDetailDrawer.vue?vue&type=script&lang=js"

import "./AlimtalkDetailDrawer.vue?vue&type=style&index=0&id=1153035b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1153035b"]])

export default __exports__